import axios from "axios"
import baseUrl from "./apiUrl";

export async function getGrowthIndicators_request(IdContacto){
  try {
    let url = `${baseUrl}/growthIndicators/${IdContacto}`;
    const response = await axios({
        url: url,
        method: "GET",
        headers:
        {
            'Accept': 'application/json',
            'Content-Type': 'application/json',

            'Authorization': 'Bearer ' + localStorage.getItem("token")
        }
    });
    return response.data.Respuesta;
  } catch (error) {
    throw new Error("Hubo un error al intentar obtener las vacunas.");
  }
};
